import React from 'react'
import styled from 'styled-components'
import {Button, Card, CardBody, Heading, Text} from '@eggplant-finance/eggplant-uikit-theme'
import useI18n from 'hooks/useI18n'
// import { useGetStats } from 'hooks/api'
import {useTotalValue} from '../../../state/hooks'
import CardValue from './CardValue'
import UnlockButton from "../../../components/UnlockButton";



const StyledCardBody = styled(CardBody)`
  width: 30vw;
`

const InnerCardAlign = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`;


const ModiCard = styled(Card)`
  align-self: baseline;
  background: ${({theme}) => theme.isDark ? 'rgba(0, 0, 0, 0.3)' : '#FFF'};
  border-radius: 32px;
  box-shadow: ${({theme})=> theme.isDark ? '0px 0px 5px 5px rgba(232, 226, 251, 0.2)' : '0px 0px 5px 5px rgba(107, 10, 128, 0.2)' };
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 24px;
  position: relative;
  text-align: center;
`


const ModiHeader = styled(Heading)`
  color: ${({theme})=> theme.isDark ? '#e8e2fb' : '#460a80'}
`;

const ModiText = styled(Text)`
  color: ${({theme})=> theme.isDark ? '#e8e2fb' : '#460a80'}
`

const TotalValueLockedCard = () => {
    const TranslateString = useI18n()
    // const data = useGetStats()
    const totalValue = useTotalValue()
    // const tvl = totalValue.toFixed(2);

    return (
        <ModiCard>
        <CardBody>
                <ModiHeader size="lg" mb="24px">
                    {TranslateString(997, 'Total Value Locked (TVL)')}
                </ModiHeader>
                <>
                    {/* <Heading size="xl">{`$${tvl}`}</Heading> */}
                    {/* <Heading size="xl"> */}
                    <ModiText color="textSubtle" bold>{TranslateString(1004, 'all Lps and Pools')}</ModiText>
                    <CardValue value={totalValue.toNumber()} prefix="$" decimals={2}/>
                    {/* </Heading> */}
                </>
        </CardBody>
        </ModiCard>
    )
}

export default TotalValueLockedCard
